import React from "react";
import "../style/About.css";
// import Banner from "../component/Banner";
import { skills } from "../utils/info";
import useScrollToTop from "../utils/useScrollToTop";

const About = () => {
  useScrollToTop();

  return (
    <>
      {/* <Banner /> */}
      <div className="about-container">
        <div className="content-container">
          <div className="profile-picture"></div>
          <div className="bio">
            <h1 style={{ padding: "5px" }}>
              Hi, I'm <strong>Tilak Singh</strong>! 👋
            </h1>
            <div className="description">
              <p>
                I hold a <b>Master of Science in Computer Science</b> from the
                <b> University of Colorado, Boulder</b>. <b>SKO! BUFFS 🦬</b>
              </p>
              <p>
                At <b>PayPal</b>, I work as a <b>Software Engineer 2</b> on the
                Financial Services Debit Card Platform, contributing to the
                <b> PayPal Everywhere (PPE)</b> vision. I’ve driven initiatives
                that scale to <b>$22B+ in daily transactions</b> and onboarded
                <b> 50M+ users</b>, building distributed systems that power
                global payments.
              </p>
              <p>
                Previously, I interned with PayPal’s <b>Checkout team</b>,
                where I built observability tools to monitor
                <b> millions of transactions per second</b> and improved
                system reliability. My focus is designing
                <b> scalable distributed systems</b> and
                <b> AI/ML infrastructure</b>, always with a
                <b> performance and reliability-first</b> mindset.
              </p>
            </div>


          </div>
        </div>

        <div className="skill-container">
          <center>{/* <h1>Skills</h1> */}</center>
          <div className="skill-list">
            {Object.entries(skills).map(([category, skillsList]) => (
              <div className="skill-column" key={category}>
                <div className="skill-card">
                  <h2>{category}</h2>
                  <ul>
                    {skillsList.map((skill, index) => (
                      <li key={index}>{skill}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
